import { DEFAULT_DEPARTMENT, normalizeDepartment } from "./departments";

const ISSUE_STATUS_TESTING = "Testing";

/** Kanban column display labels by department (DB status keys unchanged). */
const BOARD_STATUS_LABELS = {
  "Tech Team": {
    Open: "Open",
    "In Progress": "In Progress",
    Testing: "In Review",
    Blocked: "Blocked",
    Done: "Done",
  },
  Marketing: {
    Open: "Open",
    "In Progress": "In Progress",
    Testing: "Published",
    Blocked: "On Hold",
    Done: "Completed",
  },
  CSM: {
    Open: "Open",
    "In Progress": "In Progress",
    Testing: "Customer Review",
    Blocked: "On Hold",
    Done: "Closed",
  },
  IT: {
    Open: "Open",
    "In Progress": "In Progress",
    Testing: "In Review",
    Blocked: "Blocked",
    Done: "Resolved",
  },
  HR: {
    Open: "Open",
    "In Progress": "In Progress",
    Testing: "Review",
    Blocked: "Blocked",
    Done: "Complete",
  },
};

export const DEPARTMENT_ACCENTS = {
  "Tech Team": { bg: "#EAF6FD", color: "#2C63AE", border: "#a9ddf5", iconBg: "#EAF6FD" },
  Marketing: { bg: "#fdf4ff", color: "#a21caf", border: "#f0abfc", iconBg: "#fae8ff" },
  CSM: { bg: "#ecfeff", color: "#0e7490", border: "#a5f3fc", iconBg: "#cffafe" },
  IT: { bg: "#ecfdf5", color: "#047857", border: "#6ee7b7", iconBg: "#d1fae5" },
  HR: { bg: "#fff7ed", color: "#c2410c", border: "#fed7aa", iconBg: "#ffedd5" },
};

const CLOSED_DONE_STATUSES = new Set([
  "Done",
  "Fixed",
  "Closed",
  "Not Reproducible",
  "Cannot Reproduce",
  "Invalid",
  "Won't Fix",
  "Duplicate",
]);

function labelsForDepartment(department) {
  const dept = normalizeDepartment(department);
  return BOARD_STATUS_LABELS[dept] || BOARD_STATUS_LABELS[DEFAULT_DEPARTMENT];
}

/** User-facing Kanban column / status label for a department. */
export function getBoardStatusLabel(status, department = DEFAULT_DEPARTMENT) {
  if (status == null || status === "") return "";
  const labels = labelsForDepartment(department);
  if (CLOSED_DONE_STATUSES.has(status)) return labels.Done;
  return labels[status] ?? status;
}

/** Status dropdown options on Kanban cards (values stay API-compatible). */
export function getWorkflowStatusOptionsForDepartment(department = DEFAULT_DEPARTMENT) {
  const labels = labelsForDepartment(department);
  const options = [
    { value: "Open", label: labels.Open },
    { value: "In Progress", label: labels["In Progress"] },
    { value: ISSUE_STATUS_TESTING, label: labels.Testing },
  ];
  if (department !== "Marketing") {
    options.push({ value: "Blocked", label: labels.Blocked });
  }
  return options;
}

export function getDepartmentAccent(department = DEFAULT_DEPARTMENT) {
  const dept = normalizeDepartment(department);
  return DEPARTMENT_ACCENTS[dept] || DEPARTMENT_ACCENTS[DEFAULT_DEPARTMENT];
}
